import { Button, Grid, Typography } from '@mui/material';
import { getData } from 'apis/controllers/apiEntities';
import { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

const ResultsEventJsonForm = () => {
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState([]);
    const [eventInfo, setEventInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const gridRef = useRef();

    const fetchEventData = async () => {
        setIsLoading(true);
        try {
            const res = await getData({ dataKey: 'Admin-Config-Result-Event-Manage', parameters: { eventId: id } });
            setData(res?.data || []);
            setEventInfo(res?.message || null);
        } catch (error) {
            enqueueSnackbar(error?.message || 'Αποτυχία φόρτωσης mapping αποτελεσμάτων.', { variant: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEventData();
    }, []);

    const buildMappingPayload = () => {
        const grid = gridRef.current;

        grid?.finishEditing();
        grid?.collectionView?.commitEdit();
        grid?.collectionView?.commitNew();

        return (grid?.collectionView?.items || [])
            .filter((item) => item?.fldName && `${item.fldName}`.trim() !== '')
            .map((item) => ({
                fldName: item.fldName,
                fldTitle: item.fldTitle || '',
                fldTitleb423: item.fldTitleb423 || '',
                fldHidden: !!item.fldHidden,
                fldHiddenb423: !!item.fldHiddenb423
            }));
    };

    const handleSubmit = async () => {
        setIsSaving(true);
        try {
            await getData({
                dataKey: 'Adming-Config-Result-Event-Save',
                parameters: { eventId: id, json: buildMappingPayload() }
            });

            enqueueSnackbar('Το mapping αποτελεσμάτων αποθηκεύτηκε.', { variant: 'success' });
            await fetchEventData();
        } catch (error) {
            enqueueSnackbar(error?.message || 'Αποτυχία αποθήκευσης mapping αποτελεσμάτων.', { variant: 'error' });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Grid container spacing={2} sx={{ padding: 4 }}>
            <Grid item xs={12}>
                <Typography variant="h3">
                    {eventInfo?.Id} - {eventInfo?.Name} - {eventInfo?.Abbr}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FlexGrid
                    itemsSource={data}
                    initialized={(flex) => {
                        gridRef.current = flex;
                    }}
                    className="explorer-grid"
                    visible
                    allowAddNew
                    isDisabled={isLoading || isSaving}
                >
                    <FlexGridColumn binding="fldName" header="field Name" visible />
                    <FlexGridColumn binding="fldTitle" header="field Title" visible />
                    <FlexGridColumn binding="fldTitleb423" header="field Title BEFORE (2023)" visible />
                    <FlexGridColumn binding="fldHidden" header="field Hidden" visible dataType="Boolean" />
                    <FlexGridColumn binding="fldHiddenb423" header="field Hidden BEFORE(2023)" visible dataType="Boolean" />
                </FlexGrid>
            </Grid>
            <Grid item xs={12}>
                <Button variant="contained" onClick={handleSubmit} disabled={isLoading || isSaving}>
                    Αποθήκευση
                </Button>
            </Grid>
        </Grid>
    );
};
export default ResultsEventJsonForm;
